module.exports = __webpack_public_path__ + "static/media/select-grey.8fe41320.svg";